import { createRoot } from "react-dom/client";
import { createElement } from "react";
import App from "../components/App.jsx";
import { watchHeight } from "../lib/iframeHeight.js";

import "../styles/styles.scss";
import "../styles/icons.data.svg.css";
import "../styles/icons.fallback.scss";
import "../styles/alerts.scss";
import "../styles/divider.scss";
import "../styles/table.scss";
import "../styles/visibility.scss";
import "../styles/overrides.scss";
import "../styles/returns.scss";

function mount() {
  const node = document.getElementById("app");
  if (!node) return;
  createRoot(node).render(createElement(App, { data: JSON.parse(node.dataset.props) }));
  // The embedding channels size the iframe from the height we post back.
  watchHeight(node);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mount);
} else {
  mount();
}
